// import anime from 'animejs'
import BB_Header from './header'
// import BB_Elements from './elements'

export default class BB_Cart {
    constructor() {
        BB_Cart.body_overlay = jQuery('#ob-body-overlay')
        BB_Cart.body = document.querySelector('body')
        BB_Cart.html = document.querySelector('html')
        BB_Cart.cart_sidebar_open = 0

        BB_Cart.cart_header_btn = jQuery('.ob-cart-btn-wrap')
        BB_Cart.cart_sidebar = jQuery('.ob-cart-menu-wrap')
        BB_Cart.cart_sidebar_close_btn = jQuery('.ob-cart-menu-close-btn')

        BB_Cart.cart_sidebar_item_count = jQuery('.ob-cart-menu-items span')
        BB_Cart.cart_sidebar_content = jQuery('.ob-cart-menu-content')
        BB_Cart.cart_sidebar_subtotal_price = jQuery('.ob-cart-menu-sub-total .ob-price')
        BB_Cart.cart_sidebar_shipping_price = jQuery('.ob-cart-menu-shipping .ob-price')
        BB_Cart.cart_sidebar_total_price = jQuery('.ob-cart-menu-total .ob-price')

        BB_Cart.init()
    }
    static init() {
        console.log('cart.js init');

        BB_Cart.cart_header_btn.on('click', BB_Cart.sidebar_open)
        BB_Cart.body_overlay.on('click', BB_Cart.sidebar_close)
        BB_Cart.cart_sidebar_close_btn.on('click', BB_Cart.sidebar_close)

        BB_Cart.quantity_form()
        jQuery(document).on('click', '.ob-cart-item-bin', BB_Cart.cart_item_bin)

    }
    static refresh() {
        BB_Header.cart_start_loading();
        BB_Cart.start_loading();

        BB_Cart.refresh_cart_ajax();
    }
    static start_loading() {
        BB_Cart.cart_sidebar.addClass('ob-cart-menu-loading')
    }
    static end_loading() {
        BB_Cart.cart_sidebar.removeClass('ob-cart-menu-loading')
    }
    static sidebar_open() {
        BB_Cart.body.classList.add('ob-overlay-active')
        BB_Cart.body.classList.add('ob-cart-menu-active')

        BB_Cart.html.classList.add('ob-scroll-lock')
        BB_Cart.cart_sidebar_open = 1
        // anime({
        //     targets: BB_Cart.cart_sidebar,
        //     right: '0px',
        //     duration: 800,
        //     easing: 'easeInOutQuart'
        // })
    }
    static sidebar_close() {
        BB_Cart.body.classList.remove('ob-overlay-active')
        BB_Cart.body.classList.remove('ob-cart-menu-active')

        BB_Cart.html.classList.remove('ob-scroll-lock')
        BB_Cart.cart_sidebar_open = 0

        // anime({
        //     targets: BB_Cart.cart_sidebar,
        //     right: '-330px',
        //     duration: 800,
        //     easing: 'easeInOutQuart'
        // })
    }
    static update_sidebar_count(count) {
        if (count) {
            BB_Cart.cart_sidebar_item_count.html(count);
        }
    }
    static update_sidebar_content(items) {
        // if no items, <figure><p>Add some items to the cart.</p></figure>

        if (items) {
            BB_Cart.cart_sidebar_content.html(items);
        }
    }
    static update_sidebar_subtotal(subtotal_string) {
        if (subtotal_string) {
            BB_Cart.cart_sidebar_subtotal_price.html(subtotal_string);
        }
    }
    static update_sidebar_shipping(shipping_string) {
        if (shipping_string) {
            BB_Cart.cart_sidebar_shipping_price.html(shipping_string);
        }
    }
    static update_sidebar_total(total_string) {
        if (total_string) {
            BB_Cart.cart_sidebar_total_price.html(total_string);
        }
    }
    static quantity_form() {
        const $ = jQuery;

        $(document).on('click','.qty-plus-cart', function (e) {
            const $this = $(this);
            let $input = $this.prev('input.qty');
            let val = parseInt($input.val());
            let stock_quantity = $this.closest('.ob-quantity').data('stock-quantity');
            let new_val = (val + 1);
            let cart_product = $this.closest('.ob-cart-menu-product');

            if ( new_val <= stock_quantity) {
                $input.val(new_val).on('change');
                $input.attr('value', new_val);

                BB_Header.cart_start_loading();
                BB_Cart.start_loading();

                BB_Cart.update_cart_quantity(cart_product.data('cart-item-key'), new_val)
            }
        });

        $(document).on('click', '.qty-minus-cart', function (e) {
            const $this = $(this);
            let $input = $this.next('input.qty');
            let val = parseInt($input.val());
            let cart_product = $this.closest('.ob-cart-menu-product');

            if (val > 1) {
                let new_val = val - 1;

                $input.val(new_val).on('change');
                $input.attr('value', new_val);
                
                BB_Header.cart_start_loading();
                BB_Cart.start_loading();

                BB_Cart.update_cart_quantity(cart_product.data('cart-item-key'), new_val)
            }
        });
    }
    static async update_cart_quantity(cart_item_key, new_quantity) {
        console.log(cart_item_key);
        console.log(new_quantity);

        const request_body = {
            security: ajax_object.update_cart_quantity_nonce,
            action: "update_cart_quantity_action",
            data: [cart_item_key, new_quantity]
        }
        const request = {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: jQuery.param(request_body)
        }
        try {
            const respose = await fetch(ajax_object.ajax_url, request);
            const response_json = await respose.json();

            console.log(response_json);

            if (response_json.success) {
                // BB_Header.cart_end_loading();
                // BB_Cart.end_loading();
                BB_Cart.refresh_cart_ajax()
            }

        } catch (err) {
            console.log(err);
        }
    }
    static async refresh_cart_ajax() {
        const request_body = {
            security: ajax_object.refresh_cart_nonce,
            action: "refresh_cart_action",
            data: ['test']
        }
        const request = {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: jQuery.param(request_body)
        }
        try {
            const respose = await fetch(ajax_object.ajax_url, request);
            const response_json = await respose.json();

            console.log(response_json);

            if (response_json.success) {
                const [cart_count, cart_items, subtotal, shipping_total, total] = response_json.data

                BB_Header.cart_item_count(cart_count);

                BB_Cart.update_sidebar_count(cart_count);
                BB_Cart.update_sidebar_content(JSON.parse(cart_items));
                BB_Cart.update_sidebar_subtotal(JSON.parse(subtotal))
                // BB_Cart.update_sidebar_shipping( JSON.parse(shipping_total) )
                BB_Cart.update_sidebar_total(JSON.parse(total))

                BB_Header.cart_end_loading();
                BB_Cart.end_loading();

                // new BB_Elements;
            }

        } catch (err) {
            console.log(err);
        }
    }
    static cart_item_bin() {
        let $this = jQuery(this);
        const cart_item_key = $this.closest('.ob-cart-menu-product').data('cart-item-key');
        
        BB_Header.cart_start_loading();
        BB_Cart.start_loading();

        BB_Cart.remove_cart_item(cart_item_key);
    }
    static async remove_cart_item(cart_item_key) {
        const request_body = {
            security: ajax_object.remove_cart_item_nonce,
            action: "remove_cart_item_action",
            data: cart_item_key
        }
        const request = {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
            },
            body: jQuery.param(request_body)
        }
        try {
            const respose = await fetch(ajax_object.ajax_url, request);
            const response_json = await respose.json();

            console.log(response_json);

            if (response_json.success) {
                BB_Cart.refresh_cart_ajax()
            }

        } catch (err) {
            console.log(err);
        }
    }
}